import { PALETTE } from '../tokens';

export function ScoreRing({ score, size = 86, stroke = 4.5, transitionMs = 900 }) {
  const r = (size - stroke * 2) / 2;
  const circ = 2 * Math.PI * r;
  const safeScore = Math.max(0, Math.min(100, score || 0));
  const offset = circ - (safeScore / 100) * circ;
  return (
    <svg width={size} height={size} style={{ transform: "rotate(-90deg)" }}>
      <circle cx={size/2} cy={size/2} r={r} fill="none" stroke={PALETTE.border} strokeWidth={stroke} />
      <circle cx={size/2} cy={size/2} r={r} fill="none"
        stroke={PALETTE.primary} strokeWidth={stroke}
        strokeDasharray={circ} strokeDashoffset={offset}
        strokeLinecap="round"
        style={{ transition: `stroke-dashoffset ${transitionMs}ms cubic-bezier(0.22, 1, 0.36, 1)` }}
      />
    </svg>
  );
}
